import { useCallback, useEffect, useState } from 'react';
import { isFunction } from 'lodash';
import { useCurrencies, defaultCurrency, Currency } from '@zapier/currency';

type Input = {
  currency?: string;
  onSelectCurrency?: (currency: string) => void;
  switchEnabled: boolean | undefined;
};

export const useSelectedCurrency = ({
  currency,
  onSelectCurrency,
  switchEnabled,
}: Input) => {
  const [selectedCurrency, setSelectedCurrency] = useState('USD');
  const { isLoading: isLoadingCurrencies, currencies } = useCurrencies();

  const currentCurrency = switchEnabled
    ? currencies.find(
        currency
          ? (c: Currency) => c.name === currency
          : (c: Currency) => c.name === selectedCurrency
      ) ?? defaultCurrency
    : defaultCurrency;

  // If currency is being controlled externally, set state to given value
  useEffect(() => {
    if (currency) {
      setSelectedCurrency(currency);
    }
  }, [currency, setSelectedCurrency]);

  const onSelectCurrencyCallback = useCallback(
    (newCurrency: Currency) => {
      // This function is only called when provided, meaning it's being controlled externally
      if (isFunction(onSelectCurrency)) {
        onSelectCurrency(newCurrency.name);
      }
      setSelectedCurrency(newCurrency.name);
    },
    [onSelectCurrency, setSelectedCurrency]
  );

  return {
    selectedCurrency: currentCurrency,
    setSelectedCurrency: onSelectCurrencyCallback,
    isLoading: isLoadingCurrencies,
  };
};
